

























import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import HoverDescription from '@/components/atoms/HoverDescription.vue';
import { getUrlTarget } from '@/containers/globals/Util';
import { ClickProductUrlEvent, ID, Product } from '@/types/type';
import { REL } from '@/utils/consts';

@Component({ components: { HoverDescription } })
export default class LinkButton extends Vue {
  @Prop()
  private id!: ID;

  @Prop()
  private title!: string;

  @Prop()
  private url!: string;

  @Prop()
  private product!: Product;

  @Prop()
  private description!: string;

  @Prop()
  private available!: boolean;

  private menuTitlte: string = this.title.length ? this.title : this.url;
  private disabled: boolean = !this.title.length && !this.description.length;

  @Emit('button-link-opened')
  private moveLink(): ClickProductUrlEvent {
    return { menuId: this.id, product: this.product, url: this.url };
  }
}
